import { Component, OnInit, Input } from '@angular/core';
import { AppSettings, enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
import { mywalletstore } from '../../../_services/mywallet/store/mywallet.store.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { ErrorPopupComponent } from '../../../sharedcomponents/_directive/error-popup/error-popup.component';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Router, CanActivate } from '@angular/router';
import { AlertPopupComponent } from '../../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { InfoPopupComponent } from '../../../sharedcomponents/_directive/info-popup/info-popup.component';
// import { DeletestoreComponent } from '../deletestore/deletestore.component';
import { StoreDetails } from '../../../models/sendmoney/sendmoney';
@Component({
  selector: 'app-storelist',
  templateUrl: './storelist.component.html',
  styleUrls: ['./storelist.component.css']
})
export class StorelistComponent implements OnInit {
  storeid: string;
  storeList: any = [];
  storeNotFound = '';
  mobileScreen = false;

  @Input() positions = [];
  constructor(private storeservice: mywalletstore, public utilityServ: utilityService, private translate: TranslateService, private modal: Modal, private router: Router) {}

  ngOnInit() {
    this.getstorelist();

    if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
      this.mobileScreen = true;
    } else {
      this.mobileScreen = false;
    }
  }
  getstorelist() {
    this.utilityServ.busy = this.storeservice.getstorelistservice().subscribe(
      data => {
        if (data.Envelope.Body.StoresResponse.StatusCode == 20001) {
          return false;
        }
        if (data.Envelope.Body.StoresResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          if (data.Envelope.Body.StoresResponse.Stores.StoreDetail != undefined) {
            this.storeList = this.utilityServ.getArray(data.Envelope.Body.StoresResponse.Stores.StoreDetail);
            this.storeList = this.storeList.filter(storeData => this.utilityServ.getObjectText(storeData.Status) != 'false');
          } else {
            //console.log('No store');
            this.storeNotFound = this.translate.instant('Common_lblNoRecordFound');
            // this.nostoreFound(data);
          }
        } else {
          this.storeNotFound = this.translate.instant('Common_lblNoRecordFound');
          //console.log('No store');
          // this.nostoreFound(data);
          return true;
        }
      },
      error => {
        //console.log('Unable to fetch Store Image' + error);
      }
    );
  }
  nostoreFound(data) {
    const modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblOops').toString();
    modalData.Message = this.translate.instant('Common_lblNoRecordFound');
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  // deletestore(store) {
  //   const modalData: any = {};
  //   const _self = this;
  //   modalData.Title = this.translate.instant('Common_lblInfo').toString();
  //   modalData.Message = this.translate.instant('DeleteStorePopup_desc').toString();
  //   modalData.Action = this.translate.instant('Common_lblContinue').toString();
  //   modalData.store = store;
  //   //  this.modal.overlay.defaultViewContainer = this.vcRef;
  //   return this.modal.open(DeletestoreComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
  //     obj.onDestroy.subscribe(data => {
  //       if (modalData.next == 'yes') {
  //         const modalData: any = {};
  //         modalData.Title = _self.translate.instant('Common_lblInfo').toString();
  //         modalData.Action = _self.translate.instant('Common_lblOk').toString();

  //         _self.storeservice.deletestoreservice(_self.utilityServ.getObjectText(store.StoreID)).subscribe(
  //           data => {
  //             if (data.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
  //               modalData.Message = _self.translate.instant('MyWallet_lblDeleteMessage').toString();
  //             } else {
  //               modalData.Message = _self.translate.instant('Message_errorMessage').toString();
  //             }
  //             return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
  //               obj.onDestroy.subscribe(data => {
  //                 _self.ngOnInit();
  //               });
  //             });
  //           },
  //           error => {
  //             //console.log('Something went wrong,Unable to delte cart Item');
  //             this.closePopup();
  //           }
  //         );
  //       } else {
  //         // _self.closePopup();
  //       }
  //     });
  //   });
  // }
  // openstore(store) {
  //   // this.storeservice.setStoreData(store);
  //   // this.router.navigate(['/Storemap']);
  //   window.open(
  //     'https://www.google.com/maps/dir/?api=1&origin=My+Location&destination=' +
  //       this.utilityServ.getObjectText(store.Address.Address1) +
  //       ' ' +
  //       this.utilityServ.getObjectText(store.Address.City) +
  //       ' ' +
  //       this.utilityServ.getObjectText(store.Address.StateCode) +
  //       ' ' +
  //       this.utilityServ.getObjectText(store.Address.CountryCode)
  //   );
  //   return;
  // }

  clickStoreDetails(storeDetail) {
    let store = this.initializestore(storeDetail);
    this.storeservice.setStoreData(store);
    this.router.navigate(['/storelocatorstoredetail']);
  }

  initializestore(obj) {
    const storeDetails: StoreDetails = new StoreDetails();
    storeDetails.storeId = this.utilityServ.getObjectText(obj.StoreID);
    // storeDetails.storeaddress = obj.Address;
    storeDetails.storeaddress.Address1 = this.utilityServ.getObjectText(obj.Address.Address1);
    storeDetails.storeaddress.CityCode = this.utilityServ.getObjectText(obj.Address.City);
    storeDetails.storeaddress.CountryCode = this.utilityServ.getObjectText(obj.Address.CountryCode);
    storeDetails.storeaddress.Latitude = this.utilityServ.getObjectText(obj.Address.Latitude);
    storeDetails.storeaddress.Longitude = this.utilityServ.getObjectText(obj.Address.Longitude);
    storeDetails.storeaddress.StateCode = this.utilityServ.getObjectText(obj.Address.StateCode);
    storeDetails.storeaddress.ZipCode = this.utilityServ.getObjectText(obj.Address.ZipCode);
    storeDetails.storeName = this.utilityServ.getObjectText(obj.Name);
    storeDetails.storenotesSection = this.utilityServ.getObjectText(obj.Notes);
    storeDetails.storespecialInstructionSection = this.utilityServ.getObjectText(obj.SpecialInstructions);
    // storeDetails.storeOpeningTime = this.utilityServ.getObjectText(obj.TimeForThisWeek);
    storeDetails.storedirections = this.utilityServ.getObjectText(obj.Directions);
    storeDetails.storedistance = this.utilityServ.getObjectText(obj.Distance);
    storeDetails.storemail = this.utilityServ.getObjectText(obj.Email);
    storeDetails.storeLimitations = this.utilityServ.getObjectText(obj.Limitations);
    storeDetails.storePhoneNumber = this.utilityServ.getObjectText(obj.PhoneNumber);
    storeDetails.storeRestrictions = this.utilityServ.getObjectText(obj.Restrictions);
    storeDetails.storeScheduleThisWeekThisWeek = this.utilityServ.getObjectText(obj.TimeForThisWeek);

    return storeDetails;
  }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/store/storelist/storelist.component.ts